import { Type, Transform } from 'class-transformer'
import { DateTime } from 'luxon'

export default class CashBalanceTransaction {
  billing_account_id!: number
  billing_account_name!: string
  billing_account_email!: string
  customer_id!: string
  account_number!: string
  sort_code!: string
  practice_names!: string
  parent_companies!: string
  practice_group_id!: number
  practice_group_name!: string
  transaction_id!: string
  amount!: number
  ending_balance!: number
  transaction_type!: string
  reference!: string
  sender_name!: string
  sender_account_last4!: string
  sender_sort_code!: string
  invoice_id!: number
  invoice_description!: string
  invoice_number!: string
  
  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  transaction_created_at!: DateTime
  
  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  invoice_created_at!: DateTime
  
  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  invoice_finalized_at!: DateTime

  get amount_label() {
    return `£${(this.amount / 100).toFixed(2)}`
  }

  get ending_balance_label() {
    return `£${(this.ending_balance / 100).toFixed(2)}`
  }

  transaction_date_label(tz: string = 'Europe/London') {
    return this.transaction_created_at.setZone(tz).toFormat('ccc, LLL dd, yyyy, h:mm a')
  }

  get practice_group_label() {
    if (this.practice_group_id) {
      return this.practice_group_name
    } else if (this.parent_companies) {
      return `Independent (${this.parent_companies})`
    }
    return 'Independent'
  }

  get billing_account_label() {
    return `${this.billing_account_name} (${this.billing_account_email})`
  }
}